import React from 'react';

interface AcShieldLogoProps {
  style?: React.CSSProperties;
}

export function AcShieldLogo({ style }: AcShieldLogoProps) {
  const uid = React.useId().replace(/:/g, '');
  const shieldGrad = `ac-shield-outer-${uid}`;
  const innerShieldGrad = `ac-shield-inner-${uid}`;
  const capGrad = `ac-cap-${uid}`;
  return (
    <svg 
      viewBox="0 0 256 256" 
      style={{ width: '100%', height: 'auto', display: 'block', ...style }} 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Outer shield: purple gradient */}
        <linearGradient id={shieldGrad} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#a855f7" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>

        {/* Inner shield: deeper purple */}
        <linearGradient id={innerShieldGrad} x1="0" y1="0" x2="0.3" y2="1">
          <stop offset="0%" stopColor="#6d28d9" />
          <stop offset="100%" stopColor="#4c1d95" />
        </linearGradient>

        {/* Cap accent gradient: white shimmer */}
        <linearGradient id={capGrad} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#e2e8f0" />
        </linearGradient>
      </defs>

      {/* Outer Shield */}
      <path 
        d="M 128 12 Q 172 20 216 40 L 216 136 C 216 190 176 226 128 244 C 80 226 40 190 40 136 L 40 40 Q 84 20 128 12 Z" 
        fill={`url(#${shieldGrad})`}
      />
      
      {/* Inner Dark Shield */}
      <path 
        d="M 128 28 Q 166 36 194 52 L 194 136 C 194 176 164 206 128 222 C 92 206 62 176 62 136 L 62 52 Q 90 36 128 28 Z" 
        fill={`url(#${innerShieldGrad})`}
      />

      {/* Graduation Cap */}
      {/* Top Rhombus */}
      <path d="M128 86 L174 104 L128 122 L82 104 Z" fill={`url(#${capGrad})`} />
      
      {/* Base Bowl */}
      <path 
        d="M96 114 L96 142 C96 150 128 156 128 156 C128 156 160 150 160 142 L160 114 L128 126 Z" 
        fill={`url(#${capGrad})`}
      />

      {/* Tassel line */}
      <path d="M82 106 L82 144" stroke="#ffffff" strokeWidth="4" strokeLinecap="round" />
      
      {/* Tassel knot / end */}
      <path d="M78 144 L86 144 L84 156 L80 156 Z" fill="#ffffff" />
    </svg>
  );
}
